<p-dialog 
  header="Comparação de Dados do Cliente" 
  [(visible)]="visible" 
  [modal]="true" 
  [style]="{ width: '90vw', maxWidth: '1400px' }"
  [closable]="true"
  (onHide)="close()">
  
  <div *ngIf="loadingDetails || loadingOriginal" class="flex justify-center items-center py-8">
    <i class="pi pi-spin pi-spinner text-2xl"></i>
    <span class="ml-3">Carregando dados...</span>
  </div>

  <div *ngIf="!loadingDetails && !loadingOriginal && customerPendingApproval" class="p-4">
    <!-- Comparação lado a lado -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Dados Originais -->
      <div class="border-r pr-6">
        <h3 class="text-lg font-bold text-gray-800 mb-4 pb-2 border-b">
          Dados Originais
        </h3>
        
        <div *ngIf="!originalCustomer" class="text-center py-8 text-gray-500">
          <i class="pi pi-info-circle text-2xl mb-2"></i>
          <p>Cliente não encontrado no sistema</p>
          <p class="text-sm">Este pode ser um cadastro novo</p>
        </div>

        <div *ngIf="originalCustomer" class="space-y-4">

            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Nome Completo</label>
              <p class="text-gray-900 font-semibold">{{ originalCustomer.fullName || '-' }}</p>
          </div>
          
          <div class="flex justify-between mr-5">
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">CPF</label>
              <p class="text-gray-900 font-mono">{{ originalCustomer.cpf || '-' }}</p>
            </div>

            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Telefone</label>
              <p class="text-gray-900">{{ originalCustomer.phone || '-' }}</p>
            </div>
  
          </div>

          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-700 mb-1">Endereço</label>
            <p class="text-gray-900">
              {{ originalCustomer.address || '-' }}
              <span *ngIf="originalCustomer.addressNumber">, {{ originalCustomer.addressNumber }}</span>
              <span *ngIf="originalCustomer.addressComplement">, {{ originalCustomer.addressComplement }}</span>
            </p>
          </div>

          <div class="flex justify-between mr-5">
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Bairro</label>
              <p class="text-gray-900">{{ originalCustomer.district || '-' }}</p>
            </div>
  
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Cidade / Estado</label>
              <p class="text-gray-900">
                {{ originalCustomer.city || '-' }}
                <span *ngIf="originalCustomer.city && originalCustomer.state"> / </span>
                {{ originalCustomer.state || '' }}
              </p>
            </div>
  
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">CEP</label>
              <p class="text-gray-900">{{ originalCustomer.cep || '-' }}</p>
            </div>
          </div>
          
        </div>
      </div>

      <!-- Dados Pendentes de Aprovação -->
      <div class="pl-6">
        <h3 class="text-lg font-bold text-orange-600 mb-4 pb-2 border-b border-orange-200">
          Dados Pendentes de Aprovação
        </h3>

        <div class="space-y-4">
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-700 mb-1">Nome Completo</label>
            <p class="text-gray-900 font-semibold">{{ customerPendingApproval.customerFullName || '-' }}</p>
          </div>

          <div class="flex justify-between mr-5">
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">CPF</label>
              <p class="text-gray-900 font-mono">{{ customerPendingApproval.customerCpf || '-' }}</p>
            </div>

            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Telefone</label>
              <p class="text-gray-900">{{ customerPendingApproval.customerPhone || '-' }}</p>
            </div>           
          </div>

          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-700 mb-1">Endereço</label>
            <p class="text-gray-900">
              {{ customerPendingApproval.customerAddress || '-' }}
              <span *ngIf="customerPendingApproval.customerAddressNumber">, {{ customerPendingApproval.customerAddressNumber }}</span>
              <span *ngIf="customerPendingApproval.addressComplement">, {{ customerPendingApproval.addressComplement }}</span>
            </p>
          </div>

          <div class="flex justify-between mr-5">
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Bairro</label>
              <p class="text-gray-900">{{ customerPendingApproval.customerDistrict || '-' }}</p>
            </div>
  
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">Cidade / Estado</label>
              <p class="text-gray-900">
                {{ customerPendingApproval.customerCity || '-' }}
                <span *ngIf="customerPendingApproval.customerCity && customerPendingApproval.customerState"> / </span>
                {{ customerPendingApproval.customerState || '' }}
              </p>
            </div>
  
            <div class="flex flex-col">
              <label class="text-sm font-medium text-gray-700 mb-1">CEP</label>
              <p class="text-gray-900">{{ customerPendingApproval.customerCep || '-' }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="flex justify-end gap-2 mt-6 pt-4 border-t">
      <p-button
        label="Desaprovar"
        icon="pi pi-times"
        severity="danger"
        (click)="reject()">
      </p-button>
      <p-button
        label="Aprovar"
        icon="pi pi-check"
        severity="success"
        (click)="approve()">
      </p-button>
    </div>
  </div>
</p-dialog>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

